define(function (require, exports, module) {
    'use strict';

    module.exports = {
        'actions': {
            'newPaymentOrderInitiated': ['reviewTransfer']
        },

        'deps': {
            'transactions': ['accounts']
        }
    };

});



//////////////////
// WEBPACK FOOTER
// ./scripts/modules/update/config.js
// module id = 60
// module chunks = 0